export default "__VITE_ASSET__DAXlBhQB__"